import React from "react";
import "./FixedLinkedInButton.scss";
export const FixedLinkedInButton = () => {
  return (
    <>
      <div className="fixed_linkedIn_button">
        <a
          href="https://www.linkedin.com/company/counselling-india/"
          rel="nofollow"
          target="blank"
          className="btn-linkedIn"
        >
          <div className="btn-linkedIn__ico">
            <i class="fa-brands fa-linkedin"></i>
          </div>
        </a>
      </div>
    </>
  );
};
